<template>
    <div class="degnlu_box">
        <div class="wai-kuai">
            <p class="tlite-text">{{$t('logIn.logtilte')}}</p>
            <div class="lei-kuang">   
                <div class="shuru-kuang">
                    <span class="iconfont icon-yonghu"></span>
                    <input type="text" :placeholder="$t('logIn.input_plac')" v-model="Nameuse" @blur="NameuseBlur(Nameuse)">
                </div>
                <p class="zihongti" v-show="tishi.use">{{ $t('logIn.input_tishi_user') }}</p>
            </div>
            <div class="lei-kuang">   
                <div class="shuru-kuang">
                    <span class="iconfont icon-mima" style="font-size: 23px; margin-left: 9px;"></span>
                    <input :type="binType" :placeholder="$t('logIn.input_password')" v-model="Mima" @blur="MimaBlur(Mima)">
                    <span v-show="!seeMima" @click="SeMIma" class="iconfont icon-chakanmima1 chakanMIma"></span>
                    <span v-show="seeMima" @click="SeMIma" class="iconfont icon-chakan chakanMIma"></span>
                </div>
                <p class="zihongti" v-show="tishi.mima">{{$t('logIn.input_tishi_mima')}}</p>
            </div>
            <div class="clickLogin" @click="DengLuClick">{{ $t('logIn.denglu') }}</div>
            <router-link to="/zhaohui" class="Forgot">{{ $t('logIn.wangji_password') }}</router-link>
            <div class="clickRegister" @click="to_zhuce">{{ $t('logIn.no_username') }}</div>
            <div class="baozhang">
                <span class="iconfont icon-anquanbangzhu"></span>
                <p>{{$t('logIn.duowenzi')}}</p>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    export default{
        name:"denglu",
        data(){
            return{
                seeMima:false,//小眼睛
                Nameuse:'',
                Mima:'',
                tishi:{
                    use:false,
                    mima:false,
                },
                binType:'password'
            }
        },
        methods:{
            //查看密码
            SeMIma(){
                if(this.seeMima){
                    this.seeMima=false;
                    this.binType = 'password';
                }else{
                    this.seeMima=true;
                    this.binType = 'text';
                }
            },
            //用户
            NameuseBlur(e){
                e == ''?this.tishi.use = true:this.tishi.use = false
            },
            //密码
            MimaBlur(e){
                e == ''?this.tishi.mima = true:this.tishi.use = false
            },
            //登录按钮
            DengLuClick(){
                if(this.Nameuse!=='' && this.Mima !== ''){
                    // 定义请求的数据
                    const data = {
                        username:this.Nameuse,
                        password:this.Mima,
                    };
                    //歌曲
                    axios.post('api/index/login', data)
                    .then(response => {
                        // 处理请求成功的响应
                        console.log(response.data);
                        if(response.data.code == 1){
                            localStorage.setItem('Kp_state', JSON.stringify(response.data.data));
                            this.$message.success(`${response.data.msg}`);
                            this.$router.push('/home');
                            this.$router.go(0);
                        }else{
                           this.$message.error(`${response.data.msg}`);
                        }
                        
                    })
                    .catch(error => {
                        // 处理请求失败的错误
                        console.error(error);
                    });
                }else{
                    this.$message.error('账号或密码不能为空！');
                }
            },
            //跳转到注册
            to_zhuce(){
                this.$router.push('/register');
            }
        }
    }
</script>

<style scoped lang="scss">

    .degnlu_box{
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        .wai-kuai{
            width: 344px;
            height: 430px;
            // background-color: rgb(129, 129, 129);
            margin-top: 60px;
            position: relative;
            .tlite-text{
                font-size: var(--nav-text-fsize28);
                font-weight: bold;
                margin-bottom: 25px;
                color: var(--them-color);
            }
            .lei-kuang{
                width: 100%;
                height: 52px;
                display: flex;
                flex-direction: column;
                margin-bottom: 6px;
                .shuru-kuang{
                    width: 100%;
                    height: 36px;
                    display: flex;
                    align-items: center;
                    position: relative;
                    border-radius: 3px;
                    span{
                        margin-left: 12px;
                        margin-right: 12px;
                        position: absolute;
                        font-size: var(--nav-text-fsize16);
                        z-index: 10;
                        color: var(--them-color);
                    }
                    input{
                        width:88%;
                        height: 100%;
                        outline: none;
                        position: absolute;
                        border: solid 1px var(--input-border);
                        background-color: var(--input-background);
                        padding-left:39px;
                        border-radius: 3px;
                        font-weight: bold;
                        color: var(--them-color);
                        font-size:var(--nav-songTlite-fsize);
                        transition: 0.2s;
                    }
                    input:hover{
                        width:88%;
                        height: 100%;
                        position: absolute;
                        background-color: var(--background-229-230-235);
                        border: solid 1px var(--background-229-230-235);
                        
                    }
                    input:focus{
                        transition: 0.2s;
                        background-color: var(--them-background);
                        border: solid 1px var(--lan-background);
                        border-radius: 3px;
                    }
                }
                .zihongti{
                    font-size: var(--nav-text-fsize12);
                    color: var(--tishi-color);
                    margin-top: 2px;
                }
            }
            .clickLogin{
                height: 40px;
                border-radius: 3px;
                background-color: var(--lan-background);
                text-align: center;
                line-height: 40px;
                margin-top: 13px;
                cursor: pointer;
                color: #fff;
                font-size: var(--nav-songTlite-fsize);
                font-family: YuanTi;
                transition: 0.2s;
            }
            .clickLogin:hover{
                background-color: var(--lan-hover-background);
                transition: 0.2s;
            }
            .clickRegister{
                height: 40px;
                background-color: var(--to-zhuce-backround);
                margin-top: 65px;
                text-align: center;
                line-height: 40px;
                font-size: var(--nav-songTlite-fsize);
                font-family: YuanTi;
                cursor: pointer;
                transition: 0.2s;
                color: var(--to-zhuce-size);
            }
            .clickRegister:hover{
                background-color: var(--background-229-230-235);
                transition: 0.2s;
            }
            .Forgot{
                right: 0;
                position: absolute;
                margin-top: 13px;
                font-size: var(--nav-songTlite-fsize);
                color: var(--lan-background);
                font-family: YuanTi;
            }
            .baozhang{
                height: 60px;
                background-color: var(--mima-background);
                display: flex;
                align-items: center;
                margin-top: 18px;
                border-radius: 3px;
                span{
                    font-size: var(--nav-text-fsize25);
                    color: rgba(0, 255, 153,0.6);
                    margin-left: 20px;
                    margin-right: 20px;
                }
                p{  
                    width: 260px;
                    color: var(--nav-song-name-color);
                    font-size: var(--nav-text-fsize);
                    font-family: YuanTi;
                }
            }
        }
    }
    // 后加的查看密码
    .chakanMIma{
        position: absolute;
        right: 5px;
        color: var(--them-color);
        cursor: pointer;
    }
</style>